import { render, staticRenderFns } from "./one-drive-create-folder-action-output.vue?vue&type=template&id=b1560218&scoped=true"
import script from "./one-drive-create-folder-action-output.vue?vue&type=script&lang=js"
export * from "./one-drive-create-folder-action-output.vue?vue&type=script&lang=js"
import style0 from "./one-drive-create-folder-action-output.vue?vue&type=style&index=0&id=b1560218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1560218",
  null
  
)

export default component.exports